document.addEventListener("DOMContentLoaded", function () {
  function updateProductImage(card, variantData, variantId) {
    var imageElements = card.querySelectorAll(".card__media img");
    if (!imageElements.length) return;
    var lazyLoadAllVariants =
      card.getAttribute("data-lazy-load-all-variants") === "true";
    var newSrc = null;
    var newSrcset = null;
    if (lazyLoadAllVariants) {
      var preloadedImage = card.querySelector(
        `img[data-variant-id="${variantId}"]`
      );
      if (preloadedImage) {
        newSrc = preloadedImage.src;
        newSrcset = preloadedImage.srcset;
      }
    } else if (variantData && variantData.imageUrl) {
      newSrcset = [
        `${variantData.imageUrl}?width=165 165w`,
        `${variantData.imageUrl}?width=360 360w`,
        `${variantData.imageUrl}?width=533 533w`,
        `${variantData.imageUrl}?width=720 720w`,
        `${variantData.imageUrl}?width=940 940w`,
        `${variantData.imageUrl}?width=1066 1066w`,
      ].join(", ");
      newSrc = variantData.imageUrl;
    }
    if (!newSrc) return;
    // Update the main image and the hover (secondary) image, so the chosen
    // color is visible even while the mouse is over the card.
    imageElements.forEach(function (img) {
      img.removeAttribute("loading");
      if (newSrcset) img.srcset = newSrcset;
      img.src = newSrc;
    });
  }

  function updateProductLinks(card, variantData) {
    var productLinks = card.querySelectorAll(
      'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], a.card__content'
    );
    productLinks.forEach(function (link) {
      link.href = variantData.productUrl;
    });

    if (variantData.productUrl) {
      var quickAddButton = card.querySelector(".quick-add__submit");
      if (quickAddButton) {
        quickAddButton.setAttribute("data-product-url", variantData.productUrl);
      }
    }
  }

  function storeSelectedVariant(sectionId, productId, variantId) {
    sessionStorage.setItem(
      "selectedVariant-" + sectionId + "-" + productId,
      variantId
    );
  }

  function storeSelectedSwatch(sectionId, productId, variantId) {
    sessionStorage.setItem(
      "selectedSwatch-" + sectionId + "-" + productId,
      variantId
    );
  }

  function restoreSelectedVariant(
    productGrid,
    sectionId,
    productId,
    variantDataMap
  ) {
    var selectedVariantId = sessionStorage.getItem(
      "selectedVariant-" + sectionId + "-" + productId
    );
    if (selectedVariantId && variantDataMap && variantDataMap[selectedVariantId]) {
      var card = productGrid.querySelector(
        `.card-product-custom-div[data-section-id="${sectionId}"][data-product-id="${productId}"]`
      );
      var variantData = variantDataMap[selectedVariantId];
      updateProductImage(card, variantData, selectedVariantId);
      updateProductLinks(card, variantData);
    }
  }

  function restoreSelectedSwatch(productGrid, sectionId, productId) {
    var selectedVariantId = sessionStorage.getItem(
      "selectedSwatch-" + sectionId + "-" + productId
    );
    if (selectedVariantId) {
      var swatchInput = productGrid.querySelector(
        `input[type="radio"][data-variant-id="${selectedVariantId}"][data-section-id="${sectionId}"][data-product-id="${productId}"]`
      );
      if (swatchInput) {
        swatchInput.checked = true;
      }
    }
  }

  function initializeProductGrid(productGrid) {
    var sectionId = productGrid.getAttribute("data-id");
    if (!sectionId) return;
    productGrid
      .querySelectorAll(".card-product-custom-div")
      .forEach(function (card) {
        if (card.dataset.swatchInit === "true") return;
        card.dataset.swatchInit = "true";
        var productId = card.getAttribute("data-product-id");
        var variantDataMap =
          window[
            "variantDataMap" + sectionId.replace(/-/g, "_") + "_" + productId
          ];
        restoreSelectedVariant(
          productGrid,
          sectionId,
          productId,
          variantDataMap
        );
        restoreSelectedSwatch(productGrid, sectionId, productId);
        card.addEventListener("change", function (e) {
          if (
            e.target.matches(
              'input[type="radio"][data-section-id="' +
                sectionId +
                '"][data-product-id="' +
                productId +
                '"]'
            )
          ) {
            var variantId = e.target.getAttribute("data-variant-id");
            var variantData = variantDataMap && variantDataMap[variantId];
            if (!variantData) {
              return;
            }
            storeSelectedVariant(sectionId, productId, variantId);
            storeSelectedSwatch(sectionId, productId, variantId);
            updateProductImage(card, variantData, variantId);
            updateProductLinks(card, variantData);
          }
        });
        card.classList.add("loaded");
      });
  }

  function initializeAllProductGrids() {
    var productGrids = document.querySelectorAll(".grid.product-grid");
    productGrids.forEach(initializeProductGrid);
  }

  initializeAllProductGrids();

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        initializeAllProductGrids();
      }
    });
  });

  var config = { childList: true, subtree: true };
  observer.observe(document.body, config);
});
